import { render, staticRenderFns } from "./mask.vue?vue&type=template&id=5b3f4ba9&scoped=true&"
import script from "./mask.vue?vue&type=script&lang=js&"
export * from "./mask.vue?vue&type=script&lang=js&"
import style0 from "./mask.vue?vue&type=style&index=0&id=5b3f4ba9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3f4ba9",
  null
  
)

export default component.exports